export const payStatusType = {
  SUCCESS: "1",
  PENDING: "2",
  FAIL: "0",
};

export const localeMap = {
  de_DE: "de",
  en_US: "en",
  es_ES: "es",
  fr_FR: "fr",
  it_IT: "it",
  ja_JP: "ja",
  ko_KR: "ko",
  pt_PT: "pt",
  ru_RU: "ru",
  tr_TR: "tr",
  vi_VN: "vi",
  zh_TW: "zh-TW",
  zh_HK: "zh-TW",
  he: "iw",
  he_IL: "iw",
  zh_CN: "zh",
  cs_CZ: "sk",
  iw_IL: "iw",
  th_TH: "th",
  sk_SK: 'sk',
};
